// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-placeholder,.bw-preview{filter:blur(30px)}.bw-placeholder{will-change:opacity;transition:opacity ease-in-out 2s}.bw-placeholder.bw-fadeOut{opacity:0}.bw-image{opacity:0}.bw-imageLoaded{opacity:1}.bw-imageLoading{filter:blur(30px)}.bw-preview,.bw-image{will-change:opacity;background-position:center;background-repeat:no-repeat;background-size:cover;transition:opacity 1s ease-in-out,filter .5s ease-in-out}.bw-imageLoaded:after{background:linear-gradient(to bottom, rgba(18, 18, 18, 0.15), rgba(18, 18, 18, 0));content:\"\";display:block;height:100%;position:absolute;top:0;width:100%}@media only screen and (min-width: 1024px)and (max-width: 1599px){.bw-heroImage{min-height:70vh}}@media only screen and (min-width: 1600px){.bw-heroImage{min-height:50vh}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholder": "bw-placeholder",
	"preview": "bw-preview",
	"fadeOut": "bw-fadeOut",
	"image": "bw-image",
	"imageLoaded": "bw-imageLoaded",
	"imageLoading": "bw-imageLoading",
	"heroImage": "bw-heroImage"
};
module.exports = ___CSS_LOADER_EXPORT___;
